import script from "./step.vue?vue&type=script&setup=true&lang=js"
export * from "./step.vue?vue&type=script&setup=true&lang=js"

import "./step.vue?vue&type=style&index=0&id=7441617e&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7441617e"]])

export default __exports__